module.exports = __webpack_public_path__ + "media/message.4d53bdba.webm";